import styled from '@emotion/styled';
import { Typography, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import colors from 'assets/theme/base/colors';
import MDBox from 'components/atoms/MDBox/MDBox';

export const ModalTitle = styled(Typography)`
  color: ${colors.text.focus};
  text-align: center;
  font-weight: 700;
  font-size: 1.8rem;
`;

export const ErrorText = styled.span`
  text-align: center;
  display: block;
  color: ${colors.error.focus};
  font-weight: 400;
  font-size: 1rem;
  margin-bottom: 1rem;
`;

export const CloseIcon = styled(FontAwesomeIcon)`
  position: absolute;
  top: 0;
  right: 0;
  padding: 1rem;
  cursor: pointer;
`;

export const SearchContainer = styled.div`
  border-bottom: 2px solid #e0e0e0;
  position: relative;
`;

export const PatientSearchDropdown = styled(Box)`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: ${colors.white.main};
  border: 1px solid ${colors.primary.main};
  border-radius: 6px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
`;

export const PatientSearchDropdownItem = styled(Box)`
  padding: 0.25rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid ${colors.disabled.main};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  
  &:hover {
    background-color: ${colors.disabled.main};
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const FormContainer = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`;

export const JointSelectionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const JointSelectionBox = styled(Box)`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const JointSelectionTitle = styled(Typography)`
  color: ${colors.text.focus};
  padding-bottom: 0.5rem;
  font-weight: 600;
  font-size: 1rem;
`;

export const JointOptionsContainer = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 3rem;
`;

export const JointLabel = styled.label`
  display: flex;
  margin-right: 2rem;
`;

export const JointCheckbox = styled.input`
  margin-right: 1rem;
`;

export const JointText = styled(Typography)`
  font-weight: 600;
  font-size: 1rem;
`;

export const PriorityContainer = styled(Box)`
  display: flex;
  align-items: flex-start;
  width: 100%;
`;

export const PriorityTitle = styled(Typography)`
  color: ${colors.text.focus};
  font-weight: 600;
  font-size: 1rem;
`;

export const PrioritySwitchContainer = styled.div`
  transform: scale(0.7);
  transform-origin: center;
`;

export const PriorityDropdownContainer = styled(Box)`
  scale: 0.7;
  transform-origin: top;
  margin-bottom: -30%;
  position: relative;
  z-index: 1100;
`;

export const ModalContainer = styled(MDBox) <{ breakpointBreached: boolean }>`
  padding: 3rem;
  background-color: ${colors.white.main};
  width: ${({ breakpointBreached }) =>
    breakpointBreached ? '80%' : '60vw'};
  display: grid;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  max-height: 95vh;
  max-width: 700px;
  overflow: auto;
  position: relative;
`;

export const DatePickerWrapper = styled.div`
  position: relative;
  margin-bottom: 0.5rem;
  width: 100%;
  
  .react-datepicker-wrapper {
    width: 100%;
  }
  
  .react-datepicker__input-container {
    width: 100%;
  }
  
  .react-datepicker-popper {
    z-index: 3000;
  }
  
  .react-datepicker {
    z-index: 3000;
    border: 1px solid ${colors.primary.main};
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .react-datepicker__header {
    background-color: ${colors.white.main};
    border-bottom: 1px solid ${colors.white.main};
  }
  
  .react-datepicker__current-month,
  .react-datepicker__day-name {
    color: ${colors.primary.main};
  }
  
  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background-color: ${colors.secondary.main};
    color: ${colors.white.main};
  }
  
  .react-datepicker__day:hover {
    background-color: ${colors.secondary.focus};
    color: ${colors.white.main};
  }
  
  .react-datepicker * {
    font-family: inherit;
  }
`;